export default "__VITE_ASSET__197E8vQo__"